import { Link } from 'react-router-dom';
import { LanguageDropdown } from '../locale/language-dropdown';

export function Header() {
    return (
        <header className="w-full text-sm font-medium text-secondary p-2">
            <div className="flex justify-between items-center">
                <Link to="/" className="font-mono text-lg font-bold ps-2">シリトリ</Link>
                <div className="flex-1 flex items-center justify-end space-x-2">
                    {/* See @leave-game-dialog.tsx for an explanation of this nonsense */}
                    <div id="header-game-actions" />
                    <LanguageDropdown />
                </div>
            </div>
        </header>
    );
}
